// @flow
const RIDE_DATA_UPDATE = "ride/data/update";
const RIDE_DATA_CLEAR = "ride/data/clear";
const RIDE_WALKINGMAP_UPDATE = "ride/data/walkingmap/update";
const RIDE_WALKINGMAP_REQUEST = "ride/data/walkingmap/request";
const RIDE_DRIVER_PHONE = "ride/data/phone/set";

const MIDDLEMAN_CALL_DRIVER = "middleman/ride/call/driver";

export default {
    RIDE_DATA_UPDATE,
    RIDE_DATA_CLEAR,
    RIDE_WALKINGMAP_UPDATE,
    RIDE_WALKINGMAP_REQUEST,
    RIDE_DRIVER_PHONE,

    MIDDLEMAN_CALL_DRIVER,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRide/types.js